import { Action } from '@/_core/fluxstore/types';
import { NotificationSettingsState } from '../types';
import { useNotificationSettingsStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { SlackDisconnectCommand } from '@/api/notification-settings/commands';

const { registerMiddleware } = useNotificationSettingsStore();

export class SlackDisconnect extends Action<NotificationSettingsState> {
    public static ACTION_TYPE = 'SlackDisconnect';
    public constructor() {
        super(SlackDisconnect.ACTION_TYPE);
    }
}

const middleware = async (state: NotificationSettingsState, action: SlackDisconnect): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new SlackDisconnectCommand(),
        onSuccess: () => {
            state.slackIsConnected = false;
        },
    });
};

//@ts-ignore
registerMiddleware(SlackDisconnect.ACTION_TYPE, middleware);
